<template>
  <div id="ag-grid-demo">
    <vs-card class="p-4 mb-6">
        <div class="flex flex-wrap items-center justify-between mb-10">
            <div class="flex items-center">
                <h4 style="margin-left: 10px">Transport Order</h4>
            </div>
            <div class="flex items-center">
                <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
                <vs-button  @click="createNewTro" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
                <!-- <vs-button :to="{ name: 'transportorder-add'} " class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button> -->
                <vs-button :to="{ name: 'transportorder-view', params: {id: selectedId} }" class="mb-4 md:mb-0 mr-1" icon="remove_red_eye" :disabled="selectedId ? false : true">View</vs-button>
                <vs-button class="mb-4 md:mb-0 mr-1" @click="removeItem" icon="delete"  :disabled="selectedId ? false : true">Delete</vs-button>
                <!-- <vs-button class="mb-4 md:mb-0 mr-1" @click="filterActive" icon="filter_list">Filter</vs-button> -->
                <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list" @click="filterInit" >Filter</vs-button>
            </div>
        </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="transports"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        :pagination="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
        >
      </ag-grid-vue>
        <p class="text-right">
            <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
        </p>
        <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
    </vs-card>

    <!-- <vs-prompt
        @accept="createNewTro"
        :active.sync="popupCreateTro"
        title="New Transport Order"
        >
        <div class="con-exemple-prompt">
           <vs-radio v-model="withReference" vs-value="0" class="mb-4 mt-2">Without Outbound  Reference</vs-radio>
           <br>
           <vs-radio v-model="withReference" vs-value="1">With Outbound Reference</vs-radio>
           <vs-input placeholder="Outbound Reference" v-model="reference" class="mt-2 mb-4 w-full" :disabled="withReference == 0" v-on:keyup="keyEnter" />
           <vs-alert :active="error != ''" color="danger" icon-pack="feather" icon="icon-info">
                <span>{{error}}</span>
            </vs-alert>
        </div>
    </vs-prompt> -->

    <!-- start-filter -->
<vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
    <div class="con-exemple-prompt">
                <vs-input v-model="filter.transport_reference" class="mb-2 w-full" label="Reference" />

                <vs-input v-model="filter.awb" class="mb-2 w-full" label="AWB" />
                
                <label class="vs-input--label">Schedule Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.req_del_date_start" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.req_del_date_end" />
                    </vs-col>
                </vs-row>

                <vs-input v-model="filter.outbound_reference" class="mb-2 w-full" label="Out. Delivery" />

                <label class="vs-input--label">Transporter ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.transporter_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_transporter)"
                >
                    <vs-select-item v-for="(item, index) in ddl_transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                </vs-select>

                <label class="vs-input--label">Origin ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.origin_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_origin)"
                >
                    <vs-select-item v-for="(item, index) in ddl_origin.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
                
                <label class="vs-input--label">Destination ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.destination_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_destination)"
                >
                    <vs-select-item v-for="(item, index) in ddl_destination.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
               
                <label class="vs-input--label">Client ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_client)"
                >
                    <vs-select-item v-for="(item, index) in ddl_client.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>

            </div>
</vs-prompt>
<!-- end-filter -->

  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            withReference:0,
            reference:'',
            error:'',
            popupCreateTro:false,
            searchQuery: '',
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            transports: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            maxRetry: 10,
            showFilter: false,
            masterSync:false,
            filter: {
                transport_reference: "",
                awb: "",
                client_id: null,
                req_del_date_start: null,
                req_del_date_end: null,
                outbound_reference:"",
                transporter_id: null,
                origin_id: null,
                destination_id: null,
            },

            ddl_client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            ddl_transporter: {
                data: [],
                loading: false,
                endpoint: 'master/transporters',
                objectKey: 'transporter_code'
            },
            ddl_origin: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            ddl_destination: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },

            clientTypeOptions: [],
            areaOptions: [],

            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    computed: {
        paginationPageSize() {
            if(this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 50
        },
        totalPages() {
            if(this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        }
    },
    methods: {
        keyEnter: function(e) {
        if (e.keyCode === 13) {
            this.createNewTro();
        }
        },
        createNewTro(){
            // this.popupCreateTro = false
            // if(this.withReference == 0){
            this.$router.push({name:'transportorder-add', params:{withReference:false, dataReference:null}})
            // }else{
            //     this.$http.post('transport/transportorder/get_data_reference', {outbound_reference:this.reference})
            //     .then((resp)=>{
            //         this.$router.push({name:'transportorder-add', params:{withReference:true, dataReference:resp.data}})
            //     })
            //     .catch((error)=>{
            //         this.popupCreateTro = true
            //         if(error.response.data){
            //             this.error = error.response.data
            //         }
            //     })
            // }
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        removeItem () {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirm',
                text: 'Are you sure want to delete this transport order?',
                accept: this.acceptAlert
            })
        },
        acceptAlert() {
            this.isLoading = true
            this.$http.delete('transport/transportorder/' + this.selectedId + '/destroy')
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Transport Order deleted',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'The selected transport order was successfully deleted'
                })
            })
            .catch(error => {
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                this.$vs.notify({
                    title: 'Error',
                    text: message,
                    color: 'danger'
                })
            })
            .then(() => {
                this.fetchData()
            })
        },
        refreshData() {
            this.maxRetry = 10
            this.fetchData()
        },
        fetchData() {
            this.isLoading = true
            this.maxRetry = this.maxRetry - 1
            Promise.all([this.$http.post('transport/transportorder?page='+this.currentPage, this.filter), this.$http.post('unlock_all')])
            .then(this.$http.spread((resp, unlock) => {
                this.transports = resp.data.data
                this.totalPage = resp.data.last_page;
                this.currentPage = this.currentPage;
                this.dataTotal = resp.data.total;
                this.dataFrom = resp.data.from;
                this.dataTo = resp.data.to;
                setTimeout(() => {
                    this.isLoading = false
                }, 500)
            }))
            .catch(resp => {
                if(this.maxRetry == 0){
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.refreshData()
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                    return;
                }
                this.fetchData()
            })
        },
        viewData() {
            this.$router.push({
                name: 'transportorder-view',
                params: {
                    id: this.selectedId
                }
            })
        },
        filterData() {
            this.fetchData();
        },
        filterInit() {
            if(this.masterSync == false){
                this.$http.all([
                this.$http.post("master/customers"),
                this.$http.post('master/clients'), 
                this.$http.post("master/areas"),
                this.$http.post("master/transporters"),
                ])
                .then(
                    this.$http.spread(
                    (
                    customer,
                    clients,
                    areas,
                    transporters,
                    ) => {
                        this.ddl_origin.data = customer.data.data;
                        this.ddl_destination.data = customer.data.data;
                        this.ddl_client.data = clients.data.data;
                        this.ddl_transporter = transporters.data;
                        
                        this.ddl_origin.data.unshift({
                            id: null,
                            name: 'Any'
                        })
                        
                        this.ddl_destination.data.unshift({
                            id: null,
                            name: 'Any'
                        })
                        
                        this.ddl_client.data.unshift({
                            id: null,
                            name: 'Any'
                        })
                        
                        this.ddl_transporter.data.unshift({
                            id: null,
                            name: 'Any'
                        })

                        setTimeout(() => {
                            this.showFilter = true ;
                            this.masterSync = true ;
                        }, 500);
                    }
                )
                )
                .catch((error) => {
                    this.isLoading = false;
                    this.masterSync = false ;
                    console.log(error)
                });
            }else{
                this.showFilter = true ;
            }
        },
        searchArea(search, loading) {
            if(search.length > 2){
                loading(true)
                const data = {
                    name: search
                }
                this.$http.post('master/areas/filter/search', data)
                .then(res => {
                    this.areaOptions = res.data
                    loading(false)
                })
                .catch(() => {
                    this.searchArea(search, loading)
                })
            }
        }
    },
    mounted() {
        this.fetchData()
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: 'ID',
                field: 'id',
                width: 100,
                filter: true,
                hide: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: 'Reference',
                field: 'transport_reference',
                width: 100,
                filter: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: 'Client ID',
                field: 'client.client_code',
                width: 100,
                filter: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: 'Outbound Reference',
                field: 'outbound.outbound_reference',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Req. Del. Date',
                field: 'req_del_date',
                filter: true,
                width: 120,
                // pinned: 'left'
            },
            {
                headerName: 'AWB',
                field: 'tracking_reference',
                width: 140,
                filter: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: 'Origin',
                field: 'origin.name',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Orig. Address',
                field: 'origin.address_1',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Orig. Area',
                field: 'origin_area.village',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Destination',
                field: 'destination.name',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Dest. Address',
                field: 'destination.address_1',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Dest. Area',
                field: 'destination_area.village',
                filter: true,
                width: 150,
            },
            {
                headerName: 'Quantity',
                field: 'sum_qty',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Volume (M3)',
                field: 'base_volume',
                filter: true,
                width: 120,
            },
            {
                headerName: 'Weight (KG)',
                field: 'base_gw',
                filter: true,
                width: 120,
            },
        ];
    }
}

</script>